import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

function Icon(props) {
  return (
    <SvgIcon {...props}>
      <g>
        <g>
          <path
            class="st0"
            d="M15.7,15.1c-0.5,0-1-0.4-1-0.8c0-0.5,0.4-0.8,1-0.8s1,0.4,1,0.8c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4
			c0-0.8-0.6-1.5-1.4-1.6v-0.2c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4v0.2c-0.8,0.2-1.4,0.9-1.4,1.6c0,0.9,0.8,1.7,1.8,1.7
			c0.5,0,1,0.4,1,0.8c0,0.5-0.4,0.8-1,0.8s-1-0.4-1-0.8c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4c0,0.8,0.6,1.5,1.4,1.6v0.2
			c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4v-0.2c0.8-0.2,1.4-0.9,1.4-1.6C17.6,15.9,16.7,15.1,15.7,15.1z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            class="st0"
            d="M20.5,12.6c-0.6-0.9-1.4-1.6-2.3-2c-0.2-0.1-0.5,0-0.6,0.2c-0.1,0.2,0,0.5,0.2,0.6c1.6,0.8,2.7,2.5,2.7,4.3
			c0,0.8-0.2,1.6-0.6,2.2c-0.1,0.2,0,0.5,0.2,0.6c0.1,0,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.4-0.2c0.4-0.8,0.7-1.7,0.7-2.6
			C21.4,14.5,21.1,13.5,20.5,12.6z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            class="st0"
            d="M16.4,10L16.4,10c-0.3,0-0.5,0.2-0.5,0.4c0,0.2,0.2,0.4,0.4,0.4l0,0c0,0,0,0,0,0c0.2,0,0.4-0.2,0.4-0.4
			C16.9,10.2,16.7,10,16.4,10z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            class="st0"
            d="M13.7,19.9C12,19.1,11,17.4,11,15.6c0-0.8,0.2-1.6,0.6-2.2c0.1-0.2,0-0.5-0.2-0.6c-0.2-0.1-0.5,0-0.6,0.2
			c-0.4,0.8-0.7,1.7-0.7,2.6c0,1.1,0.3,2.1,0.9,3c0.6,0.9,1.4,1.6,2.3,2c0.1,0,0.1,0,0.2,0c0.2,0,0.3-0.1,0.4-0.2
			C14,20.3,13.9,20,13.7,19.9z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            class="st0"
            d="M15.1,20.4L15.1,20.4c-0.3,0-0.5,0.2-0.5,0.4c0,0.2,0.2,0.4,0.4,0.4l0,0c0.2,0,0.4-0.2,0.4-0.4
			S15.3,20.4,15.1,20.4z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            class="st0"
            d="M17.7,8.5c-0.1-0.1-0.1-0.2-0.2-0.4h1.1c1.1,0,2-0.9,2-2s-0.9-2-2-2h-3.5c0.2-0.3,0.4-0.7,0.4-1.1
			c0-1.1-0.9-2-2-2H2.9c-1.1,0-2,0.9-2,2s0.9,2,2,2h3.5C6.1,5.3,6,5.7,6,6.1c0,0.4,0.1,0.8,0.4,1.1H5.2c-1.1,0-2,0.9-2,2
			c0,0.6,0.3,1.2,0.8,1.6c-0.5,0.4-0.8,0.9-0.8,1.6S3.5,13.6,4,14c-0.5,0.4-0.8,0.9-0.8,1.6c0,0.6,0.3,1.2,0.8,1.6
			c-0.5,0.4-0.8,0.9-0.8,1.6c0,1.1,0.9,2,2,2h5.1c1.3,1.4,3.3,2.3,5.4,2.3c4.1,0,7.4-3.3,7.4-7.4C23.1,12.2,20.8,9.4,17.7,8.5z
			 M18.6,5c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1h-2.8H8c-0.6,0-1.1-0.5-1.1-1.1S7.4,5,8,5H18.6z M2.9,4.1C2.3,4.1,1.7,3.6,1.7,3
			s0.5-1.1,1.1-1.1h10.6c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1H2.9z M5.2,8.1h10.6c0.2,0,0.3,0,0.5,0.1c-0.2,0-0.4,0-0.6,0
			c-2,0-3.9,0.8-5.2,2.2H5.2c-0.6,0-1.1-0.5-1.1-1.1S4.6,8.1,5.2,8.1z M5.2,11.3h4.5c-0.5,0.7-0.9,1.4-1.1,2.3H5.2
			c-0.6,0-1.1-0.5-1.1-1.1C4.1,11.8,4.6,11.3,5.2,11.3z M5.2,14.4h3.2c-0.1,0.4-0.1,0.8-0.1,1.2c0,0.4,0,0.7,0.1,1H5.2
			c-0.6,0-1.1-0.5-1.1-1.1C4.1,14.9,4.6,14.4,5.2,14.4z M5.2,19.8c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1h3.4
			c0.2,0.8,0.6,1.6,1,2.3H5.2z M15.7,22.1c-3.6,0-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5S19.3,22.1,15.7,22.1z"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default Icon;
